module.exports = __webpack_public_path__ + "static/media/gift-plan-icon.109122b4.png";